import { getCurrentStep, NavSteps } from './useSyncFlowNav';

const CurrentStepToAnalyticsMap = {
  [NavSteps.VALUE_PROPS]: 'value_props',
  [NavSteps.EXTERNAL_CAL_SELECTION]: 'external_cal_sync',
  [NavSteps.SELECT_CALENDAR]: 'select_calendar',
  [NavSteps.I_CALENDAR]: 'i_cal'
};

const useSyncFlowAnalytics = () => {
  const TrackGetStartedClick = () => {
    analyticsIntegrations.track('calendar sync get started button clicked');
  };

  const TrackContinueClicked = () => {
    analyticsIntegrations.track('calendar sync continue clicked', {
      current_step: CurrentStepToAnalyticsMap[getCurrentStep()]
    });
  };

  const TrackCalendarSyncCompleted = (calType) => {
    analyticsIntegrations.track('calendar sync completed', {
      calendar_type: calType
    });
  };

  const TrackCalendarDisconnected = () => {
    analyticsIntegrations.track('calendar sync disconnect');
  };

  const TrackSyncFailed = (error) => {
    analyticsIntegrations.track('calendar sync failed', {
      detail: error,
      current_step: CurrentStepToAnalyticsMap[getCurrentStep()]
    });
  };

  return {
    TrackGetStartedClick,
    TrackContinueClicked,
    TrackCalendarSyncCompleted,
    TrackCalendarDisconnected,
    TrackSyncFailed
  };
};

export default useSyncFlowAnalytics;
